/////////////////////////////////////////////////////////////////////////////////////
// Обработчик события вступления в группу
/////////////////////////////////////////////////////////////////////////////////////
function registerGroupSubscribeFromPage(service) {
  registerSubscribe(service, 'page');
}

function registerGroupSubscribeFromBid(service) {
  registerSubscribe(service, 'bid');
}

function registerSubscribe(service, position) {
  if( ! position) {
    position = 'page';
  }

  var current_tour_id = $('#social_widgets_tour_id').val();
  $.post('/tourObject/joinGroup/?tourId=' + current_tour_id + '&service=' + service + '&position=' + position, {}, function(response) {});
}

function registerGroupUnsubscribe(service, position) {
  var current_tour_id = $('#social_widgets_tour_id').val();
  $.post('/tourObject/leaveGroup/?tourId=' + current_tour_id + '&service=' + service, {}, function(response) {});
}

/////////////////////////////////////////////////////////////////////////////////////
// Событие вступления Facebook
/////////////////////////////////////////////////////////////////////////////////////
var fbStay = setInterval(function() {
  if (typeof(FB) != 'undefined' && FB != null ) {
    clearInterval(fbStay);

    // Логируем подписывание на страницу
    FB.Event.subscribe('edge.create', function() {
      registerGroupSubscribeFromPage('facebook');
    });

    // Логируем отписывание от страницы
    FB.Event.subscribe('edge.remove', function() {
      registerGroupUnsubscribe('facebook');
    });
  }
}, 500);

/////////////////////////////////////////////////////////////////////////////////////
// Событие вступления Вконтакте
/////////////////////////////////////////////////////////////////////////////////////
if (typeof(VK) != 'undefined' && VK != null) {
  VK.Observer.subscribe("widgets.groups.joined", function f() {
    registerGroupSubscribeFromPage('vkontakte');
  });
}

/////////////////////////////////////////////////////////////////////////////////////
// Событие вступления Одноклассники
/////////////////////////////////////////////////////////////////////////////////////
function listenForJoin() {
  if (window.addEventListener) {
    window.addEventListener('message', onJoin, false);
  } else {
    window.attachEvent('onmessage', onJoin);
  }
}
function onJoin(e) {
  var args = e.data.split("$");
  if (args[0] == "ok_join") {
    registerGroupSubscribeFromPage('odnoklassniki');
  }
}
listenForJoin();
